// extracted by mini-css-extract-plugin
module.exports = {"Accordions":"styles_Accordions__xl4wp","height":"styles_height__wkbJA"};